<template>
  <i v-if="isRelevant" class="tm-tracks-fog">
    <i v-for="(rect, i) in rectangles" :key="i" :style="$_getStyle(rect)" />
  </i>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash-extended';
import gridMixin from '../grid.mixin';

export default {
  name: 'tm-tracks-fog',
  mixins: [gridMixin],

  data() {
    return {
      fogRectangles: [],
    };
  },

  computed: {
    ...mapState('timemachine', {
      sceneTrack: (state) => state.sceneEscort.sceneTrack,
      visualDuration: (state) => state.trackLayer.visualDuration,
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      pxRowBlankTop: (state) => state.cssVariables.pxRowBlankTop,
    }),
    ...mapGetters('timemachine', ['grid']),

    isRelevant() {
      return this.MODE_SCENE_EDIT && this.sceneTrack;
    },

    /** @note: additional dependency on `grid` defined in gridMixin */
    rectangles() {
      if (this.gridEstablished && this.isRelevant) {
        let rv = [];
        _.each(this.fogTimes, (time) => {
          rv = rv.concat(this.$_time2rectangles(time.start, time.end, true));
        });
        return rv;
      } else {
        return this.$data.fogRectangles;
      }
    },

    fogTimes() {
      const rv = [];

      if (0 < this.sceneTrack.data.displayStartTime) {
        rv.push({ start: 0, end: this.sceneTrack.data.displayStartTime });
      }

      const maxGridTime = _.last(this.grid).endTime;
      if (this.sceneTrack.data.displayEndTime < maxGridTime) {
        rv.push({
          start: this.sceneTrack.data.displayEndTime,
          end: maxGridTime,
        });
      }

      return rv;
    },
  },

  watch: {
    // assign fogRectangles for cache access
    rectangles: {
      handler(value) {
        this.$data.fogRectangles = value;
      },
    },
  },

  methods: {
    $_getStyle(rect) {
      return {
        width: `${rect.width}px`,
        transform: `translate(${rect.p1.x}px, ${
          rect.p1.y + this.pxRowBlankTop
        }px)`,
      };
    },
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-tracks-fog {
  > i {
    position: absolute;
    top: 0;
    height: var(--tm-pxAssetHeight);
    pointer-events: all;
    background-color: rgba(#fff, 0.8);
    z-index: var(--tm-zTracksFog);
  }
}
</style>
